'use client';

import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import { CompetitionsGate } from '@/components/social/competition/competitions-gate';
import { CompetitionsList, type CompetitionsListProps } from '@/components/social/competition/competitions-list';
import { CompetitionsPageLoading } from '@/components/social/competition/competitions-list-boundaries';
export function CompetitionsPage(props) {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <CompetitionsPageLoading />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <CompetitionsGate loading={t0}><CompetitionsList {...props} /></CompetitionsGate>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}